export default __webpack_public_path__ + "static/media/product-3.c6d47a7c.webp";